import React from 'react';
import { Link } from 'react-router-dom';

export default function Privacidad() {
  return (
    <div className="pt-24">

      <section className="py-20 bg-teal-950 text-white">
        <div className="max-w-3xl mx-auto px-6">
          <p className="text-teal-400 text-xs uppercase tracking-widest mb-4">Legal</p>
          <h1 className="font-display text-5xl md:text-6xl mb-4">Privacidad</h1>
          <p className="text-teal-200 text-lg leading-relaxed">
            Sin letra pequeña. Te explicamos exactamente qué hacemos con tus datos.
          </p>
        </div>
      </section>

      <section className="py-16 bg-stone-50">
        <div className="max-w-3xl mx-auto px-6 space-y-4">

          {/* Lo más importante */}
          <div className="bg-teal-700 rounded-2xl p-7">
            <h2 className="font-display text-2xl text-white mb-2">
              Lo más importante
            </h2>
            <p className="text-teal-100 text-sm leading-relaxed">
              <strong className="text-white">Tus datos nunca se venden, nunca se comparten
              con otras empresas y nunca se usan para publicidad.</strong>{' '}
              Solo los usamos para gestionar tu consulta y ponernos en contacto
              contigo. Nada más.
            </p>
          </div>

          {/* Qué guardamos */}
          <div className="bg-white border border-stone-100 rounded-2xl shadow-sm p-7">
            <h2 className="font-display text-xl text-stone-800 mb-3">
              ¿Qué guardamos cuando rellenas el formulario?
            </h2>
            <ul className="space-y-2 text-sm text-stone-500">
              {['Tu nombre', 'Tu email', 'Tu teléfono', 'El servicio que te interesa', 'Tu mensaje'].map(item => (
                <li key={item} className="flex items-center gap-2">
                  <span className="text-teal-600">✦</span> {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Para qué */}
          <div className="bg-white border border-stone-100 rounded-2xl shadow-sm p-7">
            <h2 className="font-display text-xl text-stone-800 mb-3">
              ¿Para qué usamos esos datos?
            </h2>
            <p className="text-sm text-stone-500 leading-relaxed">
              Únicamente para contactarte y gestionar tu consulta o cita.
              Una vez resuelta tu consulta, tus datos se eliminan a los{' '}
              <strong className="text-stone-700">5 años</strong> sin actividad
              — o antes si nos lo pides.
            </p>
          </div>

          {/* Tus derechos */}
          <div className="bg-white border border-stone-100 rounded-2xl shadow-sm p-7">
            <h2 className="font-display text-xl text-stone-800 mb-3">
              Tus derechos
            </h2>
            <p className="text-sm text-stone-500 leading-relaxed">
              Puedes pedirnos en cualquier momento que veamos, corrijamos
              o eliminemos tus datos. Solo escríbenos a{' '}
              <a href="mailto:hola@serenidadpsychology.com"
                className="text-teal-700 underline hover:text-teal-900 transition-colors">
                hola@serenidadpsychology.com
              </a>{' '}
              y lo hacemos de inmediato.
            </p>
            <p className="text-sm text-stone-400 mt-3">
              Si consideras que no hemos tratado tus datos correctamente,
              puedes reclamar ante la{' '}
              <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer"
                className="text-teal-700 underline hover:text-teal-900 transition-colors">
                Agencia Española de Protección de Datos
              </a>.
            </p>
          </div>

          {/* Responsable */}
          <div className="bg-white border border-stone-100 rounded-2xl shadow-sm p-7">
            <h2 className="font-display text-xl text-stone-800 mb-3">
              Responsable
            </h2>
            <p className="text-sm text-stone-500">
              Clínica Serenidad Psychology · Madrid, España ·{' '}
              <a href="mailto:hola@serenidadpsychology.com"
                className="text-teal-700 underline hover:text-teal-900 transition-colors">
                hola@serenidadpsychology.com
              </a>
            </p>
            <p className="text-xs text-stone-400 mt-2">
              Última actualización: mayo 2026
            </p>
          </div>

          <div className="pt-2">
            <Link to="/contacto"
              className="inline-flex items-center gap-2 text-sm text-teal-700
                         hover:text-teal-900 font-medium transition-colors">
              ← Volver al formulario
            </Link>
          </div>

        </div>
      </section>
    </div>
  );
}